import { createAsyncThunk } from '@reduxjs/toolkit'

import axiosInstance from 'libraries/axios'

export const getNewProducts = createAsyncThunk('get/products/new', async (id: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.post(
      `/v2/products/search?page=1`,
        {
          category_filter: [id],
          filter_has_special: false,
        }
    )

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const getProducts = createAsyncThunk('get/products/list', async (body: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.post(`/v2/products/search`, body)

    return data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const getProductDetails = createAsyncThunk(
  'get/product/details',
  async (productId: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`v1/products/${productId}/details`)

      return data.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const getProductOptions = createAsyncThunk(
  'get/product/options',
  async (productId: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`v1/products/${productId}/options/combined`)

      return data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const searchProducts = createAsyncThunk('search/products', async (body: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.post(`/v2/products/search`, body)

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const getBestSellers = createAsyncThunk('get/products/best-sellers', async (_: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(
      `/v2/products/best-sellers?page=1&category_filter[0]=${window.config.CATEGORY_ID}`
    )

    const bestSellers = data.data.map((item: any) => ({ ...item, isBestSeller: true }))

    return bestSellers
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})
export const getSpecialProducts = createAsyncThunk(
  'get/products/special',
  async (_: void, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `/v2/products?filter_has_special=true&page=1&per_page=16`
      )
      
      return data.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)